import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  getters: {},
});

// The shared state object that any vue component can get access to.
export const store = {
  state: {
    leagues: [],
    authenticated: false,
  },
  mutations: {
    setLeagues: function (state, value) {
      state.leagues = value;
    },
    addleague: function (state, value) {
      window.console.log("adding " + value);
      state.leagues.push.apply(value, state.leagues);
      // state.messages.push.apply(value,state.messages);
    },
    selectedDevice: function (state, value) {
      state.selectedDevice = value;
    },
    setAuthenticated: function (state, value) {
      state.authenticated = value;
    },
  },
  getters: {
    getLeagues: (state) => {
      return state.leagues;
    },
    getAuthenticated: (state) => {
      return state.authenticated;
    },
  },
};

// onSnapshot is executed every time the data
// in the underlying firestore collection changes
// It will get passed an array of references to
// the documents that match your query
// usersCollection
//   // .orderBy('createdOn', 'desc')
//   // .limit(5)
//   .onSnapshot((userRef) => {
//     const users = [];
//     userRef.forEach((doc) => {
//       const user = doc.data();
//       user.id = doc.id;
//       users.push(user);
//     });
//     console.log('Found users:', users);
//     // store.ballsInFeed = balls;
//   });
